import { AppointmentSlotsByDate } from "~/services";
import { useBreakpoint } from "~/shared";
import { TimeSlot } from "~/shared.types";
import { useSchedulingTimezoneStore } from "~/stores";
import { formatDateKey } from "~/utils";
import { ContactInfo, NoProviderData, SkeletonButton, TimeSlotChip } from ".";
import { convertSlotsToTimeZone } from "../hooks";

type FirstAvailableScheduleSectionProps = {
  selectedDate: Date;
  selectedTimeSlot: TimeSlot | null;
  onTimeSlotSelect: (timeSlot: TimeSlot, providerId?: number) => void;
  isPending?: boolean;
  appointmentSlotsByFirstAvailable?: AppointmentSlotsByDate;
};

export const FirstAvailableScheduleSection = ({
  selectedDate,
  selectedTimeSlot,
  onTimeSlotSelect,
  isPending = false,
  appointmentSlotsByFirstAvailable,
}: FirstAvailableScheduleSectionProps) => {
  const { selectedTimeZone } = useSchedulingTimezoneStore();
  const { isMobile } = useBreakpoint();
  const dateKey = formatDateKey(selectedDate);
  const slotsForDate = appointmentSlotsByFirstAvailable?.[dateKey];

  const convertedAppointmentSlots = convertSlotsToTimeZone(
    slotsForDate,
    selectedTimeZone.code,
    selectedDate,
  );

  if (!isPending && convertedAppointmentSlots.length === 0) {
    return <NoProviderData selectedDate={selectedDate} />;
  }

  return (
    <div className="max-h-96 overflow-y-auto pr-2">
      <div className="mb-4 grid grid-cols-3 gap-2 sm:grid-cols-4">
        {isPending
          ? Array.from({ length: 12 }).map((_, index) => (
              <SkeletonButton key={index} className="h-10 w-full rounded-sm" />
            ))
          : convertedAppointmentSlots?.map((slot) => (
              <TimeSlotChip
                key={slot.id}
                slot={slot}
                onSelect={onTimeSlotSelect}
                isSelected={selectedTimeSlot?.id === slot.id}
              />
            ))}
      </div>
      {isMobile && <ContactInfo />}
    </div>
  );
};
